import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

let scrollToContentLink = null
let tweenScroll = null;
let smooth_scroll_handlerFunction = null;

const init_scroll_to_content = (container) => {
    scrollToContentLink = container.querySelector('a#scrollToContentLink');
    if(scrollToContentLink){
        // console.log("add scroll tween");
        tweenScroll = gsap.to(scrollToContentLink, {
            scrollTrigger: {
                start : "top -1%",
                end: "top -50%",
                scrub: true,
                //markers:true,
                toggleActions : "play none none none",
            }, 
            yPercent: '-200',
            alpha:0
        });

        smooth_scroll_handlerFunction = scroll_main_content_handler.bind(this, scrollToContentLink, container)
        scrollToContentLink.addEventListener("click", smooth_scroll_handlerFunction);
    }
}

const scroll_main_content_handler = (scroll_link, container, e) => {
    e.preventDefault();
    const href = scroll_link.getAttribute("href");
    gsap.to(window, {duration: .75, scrollTo: href, ease: "power1.out"});

}


const desinit_scroll_to_content = (container) => {
    if(scrollToContentLink){
        // console.log("remove scroll tween");
        tweenScroll.kill();
        tweenScroll = null;
        smooth_scroll_handlerFunction = null;
        scrollToContentLink.removeEventListener("click", smooth_scroll_handlerFunction);
        scrollToContentLink = null
    }
}

export {init_scroll_to_content, desinit_scroll_to_content}